import { signal } from '@angular/core';
import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';

export abstract class FilterButton {
    selected = false;
    ariaLabel: string;
    facets: Facet[] = [];
    selectedSg = signal<boolean>(false);

    constructor(
        public id: string,
        public label: string,
        public icon: string,
        ariaLabel: string,
        facets: Array<any>
    ) {
        this.mapFacets(facets);
        this.createAriaLabel(ariaLabel);
    }

    mapFacets(facets: Array<any>) {
        this.facets = facets.map(facet => new Facet(facet.urlFriendlyId, facet.value, false, facet.group));
        this.setSelectedState();
    }

    createAriaLabel(ariaLabel: string) {
        this.ariaLabel = ariaLabel.replace('{label}', this.label);
    }

    abstract setSelectedState();
}
